var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingsAndReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "billings_and_reports",
    "data-name": "billings and reports",
    transform: "translate(-358 -100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8423",
    "data-name": "Rectangle 8423",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(358 100)",
    fill: "#404246"
  }), /*#__PURE__*/React.createElement("g", {
    id: "s1f5GT.tif",
    transform: "translate(-2035.584 -1457.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18103",
    "data-name": "Group 18103",
    transform: "translate(2405.121 1566.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31091",
    "data-name": "Path 31091",
    d: "M2420.047,1570.276v12.175c-.01.056-.025.112-.031.168a2.467,2.467,0,0,1-2.48,2.264q-4.964,0-9.927,0a2.661,2.661,0,0,1-.8-.129,2.46,2.46,0,0,1-1.687-2.428c0-3.434,0-4.867,0-8.3a2.616,2.616,0,0,1,.885-2.072c1.131-1.028,2.218-2.1,3.32-3.165a3.014,3.014,0,0,1,1.024-.743c.209-.076.425-.137.638-.2h6.813a.675.675,0,0,0,.107.034,2.474,2.474,0,0,1,2.042,1.838C2420,1569.894,2420.016,1570.087,2420.047,1570.276Zm-8.022,5.642c0-.542,0-1.084,0-1.626,0-.4-.208-.578-.6-.525a4.324,4.324,0,0,0-3.576,3.732,4.244,4.244,0,0,0,2.541,4.365,4.362,4.362,0,0,0,5.869-3.118c.1-.476-.087-.717-.571-.717h-3.1a.506.506,0,0,1-.562-.561C2412.022,1576.951,2412.024,1576.435,2412.024,1575.918Zm3.66.445c.535,0,1.07,0,1.6,0,.354,0,.48-.174.383-.508a2.788,2.788,0,0,1-.063-.3,4.222,4.222,0,0,0-3.432-3.369.5.5,0,0,0-.647.549q0,1.528,0,3.056a.514.514,0,0,0,.589.574Z",
    transform: "translate(-2405.121 -1566.836)",
    fill: "#f8f8f8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingsAndReports);
export default __webpack_public_path__ + "static/media/billings-and-reports.0b77f497882ac0be5e0526ed7a5d636e.svg";
export { ForwardRef as ReactComponent };